import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { CONFIG_URL, IS_PRODUCTION } from '../global/constants';
import { LoadingService } from './loading.service';
import { StorageService } from './storage.service';
import { Config, ConfigurationKey } from '../../proxy/models/config';

@Injectable({
    providedIn: 'root'
})
export class AppInitService {
    private readonly storageKey = 'avalonSurveysConfigs';
    private configs: Config[] = [];
    configLoadedSubject = new ReplaySubject<boolean>(1);

    constructor(
        @Inject(CONFIG_URL) public configUrl: string,
        private http: HttpClient,
        private loadingService: LoadingService,
        private storageService: StorageService
    ) {
    }

    async loadConfig(): Promise<void> {
        try {
            const storageStr = this.storageService.getData(this.storageKey, sessionStorage);
            const storage: { data: Config[]; timestamp: number } = storageStr ? JSON.parse(storageStr) : null;

            if (storage && Date.now() - storage.timestamp < 2 * 60 * 60 * 1000) {
                this.configs = storage.data;
                this.configLoadedSubject.next(true);
            } else {
                await this.getConfigsApi();
            }
        } catch (error) {
            console.error('Error loading configuration:', error);
            await this.getConfigsApi();
        }
    }

    public async getConfigsApi(): Promise<Config[]> {
        try {
            this.loadingService.showLoader();
            const data = {
                env: IS_PRODUCTION ? 'PRD' : 'UAT',
                org: 'SAL',
                app: 'Surveys',
            };

            this.configs = await this.http.post(
                this.configUrl, data, {
                    headers: {'x-functions-key': 'SLFWJ0OmUDOzE3PugCHtoOQ1JYoKWoYoiA8TPnFuI0XZAzFucHgQ3Q=='}
                }).toPromise() as Config[];
            this.storageService.saveData(this.storageKey, JSON.stringify({
                data: this.configs,
                timestamp: Date.now()
            }), sessionStorage);
            this.configLoadedSubject.next(true);
            return this.configs;
        } catch (error) {
            console.error('API call failed:', error);
            throw error;
        }
    }

    public removeConfig(): void {
        this.storageService.removeData(this.storageKey);
        this.configLoadedSubject.next(false);
    }

    public getConfigValueByKey(configKey: ConfigurationKey): string {
        return this.configs?.find(el => el.ConfigurationKey === configKey)?.ConfigurationValue || '';
    }
}
